import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# ⬇️ How to Download HawkClient

HawkClient is available for all major operating systems.

---

## 📥 Download the App

Click the **Download** button below to open the download page.

👉 [Go to Download Page](/download)

From there, you can choose the installer based on your operating system (Windows, macOS, or Linux).

👉 **Download page provides OS-specific installers**

---

## 🚀 Get Started

Once downloaded, install HawkClient and start creating workspaces, collections, and API tests.
`;

const Download = () => {
    return (
        <MarkDownRenderer
            title="Download HawkClient"
            markDownText={markdownContent}
        />
    );
};

export default Download;
